import React, { useEffect, useState } from 'react'
import {
    Card,
    CardBody,
    CardHeader,
    FbCheckbox,
    CardTitle,
    FbInput,
    GridContainer,
    GridItem,
    Typography, FbButton, Icons,
} from '@fabricks/ui-components'
import { useKeycloak } from 'react-keycloak'
import { Field, FieldProps, Form, Formik, useField } from 'formik'
import { Breadcrumbs, FormControl, Grid } from '@material-ui/core'
import { get as _get } from 'lodash'
import { Skeleton } from '@material-ui/lab'
import { useHistory } from 'react-router-dom'
import Swal from 'sweetalert2'
import { useApolloClient } from '@apollo/react-hooks'
import * as Yup from 'yup'
import Navigation from '../../../constants/navigation'
import {BoxTypeResourceList, useAddBoxTypeMutation} from '../../../api/models'
import { getContext } from '../../../services/apiService'
import { useCurrentBoxtype } from '../../../services/dataService'
import { render } from "react-dom";

interface FormValues {
    title: string
}

const renderError = (meta: any) => {
    if (meta.error) {
        return (
            <div className="error" style={{ color: 'red' }}>
                {meta.error}
            </div>
        )
    }
    return null
}

export const CreateBoxtypes = (props: any) => {
    const [keycloak] = useKeycloak()
    const history = useHistory()
    const [executeMutation, resultOfMutation] = useAddBoxTypeMutation()

    const BoxTypeSchema = Yup.object().shape({
        name: Yup.string()
            .min(2, 'You need to enter at least two characters')
            .required('This input field is required'),
        innerWidth: Yup.number().moreThan(0),
    })

    useEffect(() => {
        if (resultOfMutation.called && !resultOfMutation.loading && resultOfMutation.data) {
            const receivedData: BoxTypeResourceList = resultOfMutation.data.addBoxType || {}
            const mutationError = receivedData.error
            if (mutationError) {
                Swal.fire({
                    title: `ERROR (${mutationError.code})`,
                    text: `${mutationError.message}` || 'Error while mutating the data',
                    icon: 'error',
                    confirmButtonText: 'Ok',
                })
                return
            }
            if (resultOfMutation.data) {
                Swal.fire({
                    title: 'SUCCESS',
                    text: 'The box type was sucessfully saved',
                    icon: 'success',
                    confirmButtonText: 'Ok',
                }).then(result => {
                    if (result.value) {
                        history.push(`/masterdata/boxTypes`)
                    }
                })
            }
        }
    }, [history, resultOfMutation])

    if (resultOfMutation.called && resultOfMutation.loading) {
        return (
            <GridItem xs={12} sm={12} md={12}>
                <Card>
                    <Skeleton variant="text" animation="wave" />
                    <Skeleton variant="rect" animation="wave" width={210} height={118} />
                </Card>
            </GridItem>
        )
    }

    if (true) {
        const onSubmit = (values: any) => {
            const boxTypeCreateValue = {
                name: values.name,
                inner: {
                    width: parseInt(values.innerWidth, 10),
                    height: parseInt(values.innerHeight, 10),
                    depth: parseInt(values.innerDepth, 10),
                },
                outer: {
                    width: parseInt(values.outerWidth, 10),
                    height: parseInt(values.outerHeight, 10),
                    depth: parseInt(values.outerDepth, 10),
                },
                isActive: values.isActive,
            }
            executeMutation({
                context: getContext(keycloak.token),
                variables: { boxType: boxTypeCreateValue },
            })
        }

        return (
            <GridContainer>
                <GridItem xs={12} sm={12} md={12}>
                    <Card className="card">
                        <CardHeader isStats={false} hasIcon type="plain">
                            <div style={{ margin: '2em' }}>
                                <Breadcrumbs aria-label="breadcrumb">
                                    <Grid
                                        container
                                        direction="row"
                                        alignItems="center"
                                        style={{ cursor: 'pointer' }}
                                        onClick={() => {
                                            history.push(Navigation.Boxtypes.path)
                                        }}
                                    >
                                        <Grid item>
                                            <Icons.ArrowBackIos />
                                        </Grid>
                                        <Grid item>
                                            <span>Go back</span>
                                        </Grid>
                                    </Grid>
                                </Breadcrumbs>
                            </div>
                            <div style={{ margin: '1em' }}>
                                <CardTitle align="left" title={`New boxtype`} variant="h3" />
                            </div>
                        </CardHeader>
                        <CardBody>
                            <Formik
                                initialValues={{
                                    isActive: true,
                                }}
                                validationSchema={BoxTypeSchema}
                                onSubmit={onSubmit}
                            >
                                <Form translate="yes">
                                    <GridContainer>
                                        <GridItem xs={12} sm={12} md={12}>
                                            <FormControl fullWidth>
                                                <Field
                                                    name="name"
                                                    render={({
                                                                 field,
                                                                 form: { isSubmitting },
                                                                 meta,
                                                             }: FieldProps<FormValues>) => (
                                                        <div>
                                                            <FbInput
                                                                id="name"
                                                                label="Name"
                                                                type="text"
                                                                name="name"
                                                                className="textfield"
                                                                disabled={isSubmitting}
                                                                {...field}
                                                            />
                                                            { renderError(meta) }
                                                        </div>
                                                    )}
                                                />
                                            </FormControl>
                                        </GridItem>
                                        <GridItem xs={12} sm={6} md={6}>
                                            <FormControl fullWidth>
                                                <h3>Inner Box</h3>
                                                <Field
                                                    name="innerDepth"
                                                    render={({
                                                                 field,
                                                                 form: { isSubmitting },
                                                                 meta,
                                                             }: FieldProps<FormValues>) => (
                                                        <div>
                                                            <FbInput
                                                                id="innerDepth"
                                                                label="Inner Depth (mm)"
                                                                type="number"
                                                                name="innerDepth"
                                                                className="textfield"
                                                                disabled={isSubmitting}
                                                                {...field}
                                                            />
                                                            {meta.touched && meta.error && (
                                                                <div className="error">{meta.error}</div>
                                                            )}
                                                        </div>
                                                    )}
                                                />

                                                <Field
                                                    name="innerWidth"
                                                    render={({
                                                                 field,
                                                                 form: { isSubmitting },
                                                                 meta,
                                                             }: FieldProps<FormValues>) => (
                                                        <div>
                                                            <FbInput
                                                                id="innerWidth"
                                                                label="Inner Width"
                                                                type="number"
                                                                name="innerWidth"
                                                                className="textfield"
                                                                disabled={isSubmitting}
                                                                {...field}
                                                            />
                                                            {renderError(meta)}
                                                        </div>
                                                    )}
                                                />

                                                <Field
                                                    name="innerHeight"
                                                    render={({
                                                                 field,
                                                                 form: { isSubmitting },
                                                                 meta,
                                                             }: FieldProps<FormValues>) => (
                                                        <div>
                                                            <FbInput
                                                                id="innerHeight"
                                                                label="Inner Height"
                                                                type="number"
                                                                name="innerHeight"
                                                                className="textfield"
                                                                disabled={isSubmitting}
                                                                {...field}
                                                            />
                                                            {meta.touched && meta.error && (
                                                                <div className="error">{meta.error}</div>
                                                            )}
                                                        </div>
                                                    )}
                                                />
                                            </FormControl>
                                        </GridItem>

                                        <GridItem xs={12} sm={6} md={6}>
                                            <FormControl fullWidth>
                                                <h3>Outer Box</h3>
                                                <Field
                                                    name="outerDepth"
                                                    render={({
                                                                 field,
                                                                 form: { isSubmitting },
                                                                 meta,
                                                             }: FieldProps<FormValues>) => (
                                                        <div>
                                                            <FbInput
                                                                id="outerDepth"
                                                                label="Outer Depth"
                                                                type="number"
                                                                name="outerDepth"
                                                                className="textfield"
                                                                disabled={isSubmitting}
                                                                {...field}
                                                            />
                                                            {meta.touched && meta.error && (
                                                                <div className="error">{meta.error}</div>
                                                            )}
                                                        </div>
                                                    )}
                                                />

                                                <Field
                                                    name="outerWidth"
                                                    render={({
                                                                 field,
                                                                 form: { isSubmitting },
                                                                 meta,
                                                             }: FieldProps<FormValues>) => (
                                                        <div>
                                                            <FbInput
                                                                id="outerWidth"
                                                                label="Outer Width"
                                                                type="number"
                                                                name="outerrWidth"
                                                                className="textfield"
                                                                disabled={isSubmitting}
                                                                {...field}
                                                            />
                                                            {meta.touched && meta.error && (
                                                                <div className="error">{meta.error}</div>
                                                            )}
                                                        </div>
                                                    )}
                                                />

                                                <Field
                                                    name="outerHeight"
                                                    render={({
                                                                 field,
                                                                 form: { isSubmitting },
                                                                 meta,
                                                             }: FieldProps<FormValues>) => (
                                                        <div>
                                                            <FbInput
                                                                id="outerHeight"
                                                                label="Outer Height"
                                                                type="number"
                                                                name="outerHeight"
                                                                className="textfield"
                                                                disabled={isSubmitting}
                                                                {...field}
                                                            />
                                                            {meta.touched && meta.error && (
                                                                <div className="error">{meta.error}</div>
                                                            )}
                                                        </div>
                                                    )}
                                                />
                                            </FormControl>
                                        </GridItem>

                                        <GridItem xs={12} sm={12} md={12}>
                                            <Field
                                                name="isActive"
                                                render={({
                                                             field,
                                                             form: { isSubmitting },
                                                             meta,
                                                         }: FieldProps<FormValues>) => (
                                                    <div>
                                                        <FbCheckbox
                                                            label={"Active"}
                                                            id="isActive"
                                                            checked={!!field.value}
                                                            disabled={isSubmitting}
                                                            {...field}
                                                        />
                                                        {meta.touched && meta.error && (
                                                            <div className="error">{meta.error}</div>
                                                        )}
                                                    </div>
                                                )}
                                            />
                                        </GridItem>
                                        <GridItem xs={12} sm={12} md={12}>
                                            <FbButton
                                                variant="contained"
                                                color="primary"
                                                type="submit"
                                                style={{ marginBottom: '15px' }}>
                                                Save
                                            </FbButton>
                                        </GridItem>
                                    </GridContainer>
                                </Form>
                            </Formik>
                        </CardBody>
                    </Card>
                </GridItem>
            </GridContainer>
        )
    }
    if (resultOfMutation.loading) {
        return (
            <GridItem xs={12} sm={12} md={12}>
                <Card>
                    <Skeleton variant="text" animation="wave" />
                    <Skeleton variant="rect" animation="wave" width={210} height={118} />
                </Card>
            </GridItem>
        )
    }
    return (
        <GridItem xs={12} sm={12} md={12}>
            <Card>Currently no data</Card>
        </GridItem>
    )
}

export default CreateBoxtypes
